import React, { useState } from "react";
import { FormikProps } from "formik";
import { CustomSelect } from "../../components";

interface ProductPoliciesProps {
  formik: FormikProps<any>;
}

const ProductPolicies: React.FC<ProductPoliciesProps> = ({ formik }) => {
  const [isContributorExpanded, setIsContributorExpanded] = useState(false);
  const [isCreditExpanded, setIsCreditExpanded] = useState(false);
  const [isGeoExpanded, setIsGeoExpanded] = useState(false);

  const contributorOptions = [
    { label: "Hide", value: 1 },
    { label: "Visible", value: 2 },
    {
      label: "Visible and Mandatory",
      value: 3,
    },
  ];

  const tagOptions = [
    { label: "Hide", value: 1 },
    { label: "Visible", value: 2 },
    {
      label: "Visible and Mandatory",
      value: 3,
    },
  ];

  // Get the master contributor value (if all are the same, show that value, otherwise empty)
  const getMasterContributorValue = () => {
    const values = [
      formik.values.contributor_policy.producer,
      formik.values.contributor_policy.anchor,
      formik.values.contributor_policy.editor,
      formik.values.contributor_policy.script_writer,
      formik.values.contributor_policy.cameraman,
      formik.values.contributor_policy.photographer,
      formik.values.contributor_policy.researcher,
      formik.values.contributor_policy.compiler,
      formik.values.contributor_policy.curator,
      formik.values.contributor_policy.reporter,
      formik.values.contributor_policy.author,
    ];
    const allSame = values.every((val) => val === values[0]);
    return allSame ? values[0] : "";
  };

  // Get the master credit value (if all are the same, show that value, otherwise empty)
  const getMasterCreditValue = () => {
    const values = [
      formik.values.credits_policy.imagecredit,
      formik.values.credits_policy.videocredit,
      formik.values.credits_policy.audiocredit,
    ];
    const allSame = values.every((val) => val === values[0]);
    return allSame ? values[0] : "";
  };

  // Get the master geo value (if all are the same, show that value, otherwise empty)
  const getMasterGeoValue = () => {
    const values = [formik.values.geo_policy.gcl, formik.values.geo_policy.gct];
    const allSame = values.every((val) => val === values[0]);
    return allSame ? values[0] : "";
  };

  return (
    <>
      {/* Tags Policy */}
      <div className="row m-0 p-3 border-top">
        <div className="col-12">
          <div className="row m-0 gy-3">
            <div className="col-md-6">
              <CustomSelect
                value={formik.values.title_for_url_policy}
                label="Title for URL"
                name="title_for_url_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("title_for_url_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
              />
            </div>
            <div className="col-md-6">
              <CustomSelect
                value={formik.values.desc_policy}
                label="Description"
                name="desc_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("desc_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
              />
            </div>
            <div className="col-md-6">
              <CustomSelect
                value={formik.values.tags_policy}
                label="Tags"
                name="tags_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("tags_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
              />
            </div>
            <div className="col-md-6">
              <CustomSelect
                value={formik.values.team_policy}
                label="Team/Property"
                name="team_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("team_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
              />
            </div>
            <div className="col-md-6">
              <CustomSelect
                value={formik.values.agency_policy}
                label="Agency"
                name="agency_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("agency_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
              />
            </div>

            <div className="col-md-6">
              <CustomSelect
                value={formik.values.agency_credit_policy}
                label="Agency Credit"
                name="agency_credit_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("agency_credit_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
              />
            </div>
            <div className="col-md-6">
              <CustomSelect
                value={formik.values.ctype_policy}
                label="Content Type"
                name="ctype_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("ctype_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
              />
            </div>
            <div className="col-md-6">
              <CustomSelect
                value={formik.values.production_type_policy}
                label="Production Type"
                name="production_type_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue(
                    "production_type_policy",
                    newValue.value
                  );
                }}
                updatedOptions={tagOptions}
              />
            </div>
            <div className="col-md-6">
              <CustomSelect
                value={formik.values.content_rating_policy}
                label="Content Rating"
                name="content_rating_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("content_rating_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
              />
            </div>

            <div className="col-md-6">
              <CustomSelect
                value={formik.values.language_policy}
                label="Language"
                name="language_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("language_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
              />
            </div>
            <div className="col-md-6">
              <CustomSelect
                value={formik.values.category_policy}
                label="Category"
                name="category_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("category_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
              />
            </div>
            <div className="col-md-6">
              <CustomSelect
                value={formik.values.sub_category_policy}
                label="Subcategory"
                name="sub_category_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("sub_category_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
              />
            </div>
            <div className="col-md-6">
              <CustomSelect
                value={formik.values.expiry_policy}
                label="Expiry"
                name="expiry_policy"
                options={tagOptions}
                disabled={false}
                handleChange={(newValue: any) => {
                  formik.setFieldValue("expiry_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
                placeholder="Select Option"
              />
            </div>
            <div className="col-md-6">
              <CustomSelect
                value={formik.values.youtube_id_policy}
                label="Youtube ID"
                name="youtube_id_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("youtube_id_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
              />
            </div>
            <div className="col-md-6">
              <CustomSelect
                value={formik.values.parentid_policy}
                label="Parent ID"
                name="parentid_policy"
                options={tagOptions}
                disabled={false}
                placeholder="Select Option"
                handleChange={(newValue: any) => {
                  formik.setFieldValue("parentid_policy", newValue.value);
                }}
                updatedOptions={tagOptions}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Credits Policy */}
      <div className="row m-0 p-3 border-top">
        <div className="col-12">
          <div
            className="d-flex align-items-center justify-content-between mb-3 bg-light p-2 rounded-3"
            onClick={() => setIsCreditExpanded(!isCreditExpanded)}
          >
            <div className="text-uppercase text-secondary fw-medium">
              Credits
            </div>
            <div
              className="d-flex align-items-center gap-2"
              style={{ minWidth: "200px" }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ flex: 1 }}>
                <CustomSelect
                  value={getMasterCreditValue()}
                  name="credits_policy.master"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Apply to All"
                  handleChange={(newValue: any) => {
                    if (newValue && newValue.value) {
                      const selectedValue = newValue.value;
                      // Apply the selected value to all credit fields
                      formik.setFieldValue(
                        "credits_policy.imagecredit",
                        selectedValue
                      );
                      formik.setFieldValue(
                        "credits_policy.videocredit",
                        selectedValue
                      );
                      formik.setFieldValue(
                        "credits_policy.audiocredit",
                        selectedValue
                      );
                    }
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
            </div>
          </div>
          <div
            className={`collapse ${isCreditExpanded ? "show" : ""}`}
            id="creditChildOptions"
          >
            <div className="row m-0 gy-3">
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.credits_policy.imagecredit}
                  label="Image Credit"
                  name="credits_policy.imagecredit"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "credits_policy.imagecredit",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.credits_policy.videocredit}
                  label="Video Credit"
                  name="credits_policy.videocredit"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "credits_policy.videocredit",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.credits_policy.audiocredit}
                  label="Audio Credit"
                  name="credits_policy.audiocredit"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "credits_policy.audiocredit",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Geo Policy */}
      <div className="row m-0 p-3 border-top">
        <div className="col-12">
          <div
            className="d-flex align-items-center justify-content-between mb-3 bg-light p-2 rounded-3"
            onClick={() => setIsGeoExpanded(!isGeoExpanded)}
          >
            <div className="text-uppercase text-secondary fw-medium">
              Geo Policy
            </div>
            <div
              className="d-flex align-items-center gap-2"
              style={{ minWidth: "200px" }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ flex: 1 }}>
                <CustomSelect
                  value={getMasterGeoValue()}
                  name="geo_policy.master"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Apply to All"
                  handleChange={(newValue: any) => {
                    if (newValue && newValue.value) {
                      const selectedValue = newValue.value;
                      // Apply the selected value to all geo fields
                      formik.setFieldValue("geo_policy.gcl", selectedValue);
                      formik.setFieldValue("geo_policy.gct", selectedValue);
                    }
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
            </div>
          </div>
          <div
            className={`collapse ${isGeoExpanded ? "show" : ""}`}
            id="geoChildOptions"
          >
            <div className="row m-0 gy-3">
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.geo_policy.gcl}
                  label="Countries"
                  name="geo_policy.gcl"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue("geo_policy.gcl", newValue.value);
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.geo_policy.gct}
                  label="Mode"
                  name="geo_policy.gct"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue("geo_policy.gct", newValue.value);
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contributor Policy */}
      <div className="row m-0 p-3 border-top">
        <div className="col-12">
          <div
            className="d-flex align-items-center justify-content-between mb-3 bg-light p-2 rounded-3"
            onClick={() => setIsContributorExpanded(!isContributorExpanded)}
          >
            <div className="text-uppercase text-secondary fw-medium ">
              Contributors
            </div>
            <div
              className="d-flex align-items-center gap-2"
              style={{ minWidth: "200px" }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ flex: 1 }}>
                <CustomSelect
                  value={getMasterContributorValue()}
                  name="contributor_policy.master"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Apply to All"
                  handleChange={(newValue: any) => {
                    if (newValue && newValue.value) {
                      const selectedValue = newValue.value;
                      // Apply the selected value to all contributor fields
                      formik.setFieldValue(
                        "contributor_policy.producer",
                        selectedValue
                      );
                      formik.setFieldValue(
                        "contributor_policy.anchor",
                        selectedValue
                      );
                      formik.setFieldValue(
                        "contributor_policy.editor",
                        selectedValue
                      );
                      formik.setFieldValue(
                        "contributor_policy.script_writer",
                        selectedValue
                      );
                      formik.setFieldValue(
                        "contributor_policy.cameraman",
                        selectedValue
                      );
                      formik.setFieldValue(
                        "contributor_policy.photographer",
                        selectedValue
                      );
                      formik.setFieldValue(
                        "contributor_policy.researcher",
                        selectedValue
                      );
                      formik.setFieldValue(
                        "contributor_policy.compiler",
                        selectedValue
                      );
                      formik.setFieldValue(
                        "contributor_policy.curator",
                        selectedValue
                      );
                      formik.setFieldValue(
                        "contributor_policy.reporter",
                        selectedValue
                      );
                      formik.setFieldValue(
                        "contributor_policy.author",
                        selectedValue
                      );
                    }
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
            </div>
          </div>
          <div
            className={`collapse ${isContributorExpanded ? "show" : ""}`}
            id="contributorChildOptions"
          >
            <div className="row m-0 gy-3">
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.contributor_policy.producer || 1}
                  label="Producer"
                  name="contributor_policy.producer"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "contributor_policy.producer",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.contributor_policy.anchor}
                  label="Anchor"
                  name="contributor_policy.anchor"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "contributor_policy.anchor",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.contributor_policy.editor}
                  label="Editor"
                  name="contributor_policy.editor"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "contributor_policy.editor",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.contributor_policy.script_writer}
                  label="Script Writer"
                  name="contributor_policy.script_writer"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "contributor_policy.script_writer",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.contributor_policy.cameraman}
                  label="Cameraman"
                  name="contributor_policy.cameraman"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "contributor_policy.cameraman",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.contributor_policy.photographer}
                  label="Photographer"
                  name="contributor_policy.photographer"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "contributor_policy.photographer",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.contributor_policy.researcher}
                  label="Researcher"
                  name="contributor_policy.researcher"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "contributor_policy.researcher",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.contributor_policy.compiler}
                  label="Compiler"
                  name="contributor_policy.compiler"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "contributor_policy.compiler",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.contributor_policy.curator}
                  label="Curator"
                  name="contributor_policy.curator"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "contributor_policy.curator",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.contributor_policy.reporter}
                  label="Reporter"
                  name="contributor_policy.reporter"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "contributor_policy.reporter",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
              <div className="col-md-6">
                <CustomSelect
                  value={formik.values.contributor_policy.author}
                  label="Author"
                  name="contributor_policy.author"
                  options={contributorOptions}
                  disabled={false}
                  placeholder="Select Option"
                  handleChange={(newValue: any) => {
                    formik.setFieldValue(
                      "contributor_policy.author",
                      newValue.value
                    );
                  }}
                  updatedOptions={contributorOptions}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductPolicies;
